import React, { useEffect } from 'react';
import { useDarkMode } from '../contexts/DarkModeContext';
import aboutPageData from '../data/aboutPageData.json';
import { DescriptionSegment } from '../components/DescriptionRenderer';
import AboutPageDescription from '../components/AboutPageDescription';

const About: React.FC = () => {
    const { isDarkMode } = useDarkMode();

    const description = (aboutPageData[0]?.description || []).map((desc) => ({
        ...desc,
        type: desc.type as "text" | "link" | "internalLink",
    })) as DescriptionSegment[];

    useEffect(() => {
        document.title = "SecretAria - About";
    }, []);

    return (
        <div>
            <div className="mb-2">
                <h1 className="col kanit-extrabold">ABOUT</h1>
                <div
                    className={`card row release-info-container ${isDarkMode ? 'dark-mode-3' : 'light-mode-3'} fs-4`}
                >
                    <AboutPageDescription description={description} />
                </div>
            </div>
        </div>
    );
};

export default About;

